<template>
  <section class="join">
    <div class="container">
      <SectionTitle :small="true" class="title">
        {{ title }}
      </SectionTitle>
      <p>
        {{ text }}
      </p>
      <BaseButton
        type="secondary"
        :to="typeof buttonAction === 'string' ? buttonAction : undefined"
        @click="typeof buttonAction === 'function' ? buttonAction : undefined"
        target="_blank"
      >
        {{ buttonText }}
      </BaseButton>
    </div>
  </section>
</template>

<script>
import SectionTitle from "@/components/common/SectionTitle.vue";
import BaseButton from "@/components/common/BaseButton.vue";

export default {
  name: "JoinUsSection",
  components: { SectionTitle, BaseButton },
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonAction: {
      type: [String, Function],
      required: true,
    },
  },
};
</script>

<style scoped>
.join {
  background-color: var(--color-primary);
  color: var(--color-off-white);
  /* padding: 4rem 0; */
  padding: clamp(2rem, 1.1485rem + 3.1683vw, 4rem) 0;
  text-align: center;
  /* margin-bottom: 160px; */
  margin-bottom: clamp(4rem, 1.4455rem + 9.505vw, 10rem);
}
.container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 2rem;
}
@media screen and (max-width: 768px) {
  .container {
    flex-direction: column;
  }
}

.title {
  /* max-width: 564px; */
}

p {
  font-weight: 500;
  /* font-size: 1.375rem; */
  font-size: clamp(1rem, 0.8403rem + 0.5941vw, 1.375rem);
  line-height: 1.3;
  flex-grow: 0;
  max-width: 440px;
  text-align: left;
}
button {
  flex-shrink: 0;
}
</style>
